import { Component, Input, OnInit } from '@angular/core';
import { ResidentStatusCode } from 'src/app/security-deposit/residents/models/residents.model';

@Component({
  standalone: false,
  selector: 'app-resident-status-badge',
  templateUrl: './resident-status-badge.component.html',
  styleUrls: ['./resident-status-badge.component.scss']
})
export class ResidentStatusBadgeComponent {

  @Input() residentStatusCode?: ResidentStatusCode;
  @Input() fsdNotManaged?: boolean = false;
  ResidentStatusCode = ResidentStatusCode;
  constructor() { }
}
